export default __webpack_public_path__ + "static/delivery_back-dc5bd83d827ee0e2abcae0256c625138.png";